import { simpleAction } from 'src/ducks/utils';

import { OPEN_SIDEBAR, CLOSE_SIDEBAR, SidebarAction } from './types';

export const openSidebar = (): SidebarAction => simpleAction(OPEN_SIDEBAR);
export const closeSidebar = (): SidebarAction => simpleAction(CLOSE_SIDEBAR);
